<template>
    <!-- MODAL -->
    <TransitionRoot as="template" :show="open">
        <Dialog class="relative z-50" @close="closeDialog">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
                            <!-- Título e botão de fechar -->
                            <div class="flex justify-between items-start">
                                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Importação de Dados</h2>
                                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                                    <span class="sr-only">Fechar</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <!-- Select para escolher a empresa -->
                            <div v-if="onlyFile == false" class="mt-4">
                                <label for="empresa" class="block text-sm font-medium text-gray-700">Selecionar Empresa</label>
                                <select v-model="data.empresa_id" id="empresa" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500">
                                    <option value="" disabled selected>Escolha uma empresa</option>
                                    <option v-for="empresa in selectBoxItems" :key="empresa.id" :value="empresa.id">{{ empresa.nome }}</option>
                                </select>
                            </div>

                            <!-- Input para selecionar arquivo -->
                            <div class="mt-4">
                                <label for="file" class="block text-sm font-medium text-gray-700">Selecionar Arquivo</label>
                                <input type="file" @change="onFileChange" id="file" accept=".csv" class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500" />
                                <span v-if="fileError" class="text-red-500 text-sm">{{ fileError }}</span>
                            </div>

                            <!-- Botão de Enviar -->
                            <div class="mt-6">
                                <button @click="sendData" :disabled="!isFormValid" class="w-full inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50">
                                    Enviar
                                </button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

export default {
    name: 'CommonUpload',
    props: {
        selectBoxItems: {
            type: Array,
            required: false
        },
        open: {
            type: Boolean,
            required: true
        },
        fileOnly: {
            type: Boolean,
            required: true
        },
    },  
    data() {
        return {
            data: {  
                file: '',
                empresa_id: '',
            },
            fileError: '',
            onlyFile: this.fileOnly
        };
    },
    computed: {
        isFormValid() {
            if (this.onlyFile == false) {
                return this.data.empresa_id && this.data.file;
            }else{
                return this.data.file
            }
            
        }
    },
    watch: {
        fileOnly(newValue) {
            this.onlyFile = newValue;
        }
    },
    methods: {
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                // Valida o arquivo
                if (file.size > 15 * 1024 * 1024) { // 15 MB
                    this.fileError = 'O arquivo deve ter no máximo 15MB.';
                    this.data.file = ''; // Limpa o campo
                } else if (file.type !== 'text/csv') {
                    this.fileError = 'O arquivo deve ser um CSV.';
                    this.data.file = ''; // Limpa o campo
                } else {
                    this.fileError = '';
                    this.data.file = file; // Armazena o arquivo
                }
            }
        },
        sendData(e) {
            e.preventDefault();
            this.$emit('file-data', this.data);
        },
        closeDialog() {
            this.$emit('update-open', false);
        },
    },
    components: {
        Dialog,
        DialogPanel, 
        TransitionChild, 
        TransitionRoot
    },
}
</script>

<style scoped>
/* Adicione aqui estilos personalizados, se necessário */
</style>
